function parseIntSafe(val) {
  if (val === '' || val == null) return null;
  const n = typeof val === 'string' ? parseInt(val, 10) : val;
  return Number.isFinite(n) ? n : null;
}

// Convert input to AV, skip rounding on no-change, otherwise apply the selected increment.
export function applySettlementRounding(rawValue, isAVMode, conversionFactor, rounding, currentAV) {
  const n = parseIntSafe(rawValue);
  if (n == null) return 0;
  const av = isAVMode ? n : Math.round(n * (conversionFactor || 0));
  const assessment = Number(currentAV) || 0;
  if (assessment && av === assessment) return assessment;
  const inc = Number(rounding) || 0;
  return inc === 0 ? Math.ceil(av) : Math.round(av / inc) * inc;
}

export function computeDirection(rawValue, isAVMode, conversionFactor, finalAV) {
  const n = parseIntSafe(rawValue);
  if (n == null || !finalAV) return null;
  const diff = isAVMode ? (finalAV - n) : (finalAV / (conversionFactor || 1)) - n;
  if (diff > 0) return 'up';
  if (diff < 0) return 'down';
  return null;
}

export function computeReductionPercent(rawValue, isAVMode, propertyAssessment, ifmv) {
  const n = parseIntSafe(rawValue);
  const original = isAVMode ? propertyAssessment : ifmv;
  if (!n || !original) return { percent: null, color: 'inherit', text: null };
  let pct = ((n - original) / original) * 100;
  if (Math.abs(pct) < 0.005) pct = 0;
  const color = pct < 0 ? '#4caf50' : '#d32f2f';
  const text = pct === 0 ? '0%' : `${pct.toFixed(2)}%`;
  return { percent: pct, color, text };
}

export function applyOfferRoundingGuard(offerValueAV, propertyAssessment) {
  const currentAV = propertyAssessment || 0;
  return (offerValueAV === currentAV) ? currentAV : offerValueAV;
}
